import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { usePopoverHandlers, Popover, PopoverType, PopoverPosition, PopoverHeaderAlign, Image, ImageSize, Box, Button, ScrollableList, ScrollableListVariant, IconName, IconSize, } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { HtmlInclude } from '../html-include/HtmlInclude';
const CookiePreference = ({ preferenceData, logoUrl, isCookiePreferenceOpen, onCookiePreferenceClose, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const { handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({
        close: onCookiePreferenceClose,
    });
    const isMobile = useMediaQueryMatchesOnMobile();
    useEffect(() => {
        if (isCookiePreferenceOpen) {
            handlePopoverOpen(null, null, true, true);
        }
    }, [handlePopoverOpen, isCookiePreferenceOpen]);
    return (_jsxs(Popover, { multi: true, disableClickOutside: true, noAnimation: true, anchorEl: isCookiePreferenceOpen, type: PopoverType.MODAL, position: PopoverPosition.BOTTOM, onClose: handlePopoverClose, headerAlign: PopoverHeaderAlign.CENTER, title: _jsx(Image, { src: logoUrl, size: ImageSize.COOKIE_BRAND_LOGO }), footerElement: isMobile && (_jsx(Button, { fill: true, onClick: handlePopoverClose, text: t('cookie.consent.back.button'), iconLeft: {
                name: IconName.CHEVRON_LEFT,
                size: IconSize.MAJOR,
            } })), children: [_jsx(ScrollableList, { variant: isMobile && ScrollableListVariant.SHADOW, children: _jsx(Box, { mobile: {
                        spacing: {
                            paddingLeft: 2,
                            paddingRight: 2,
                            paddingBottom: 2,
                        },
                    }, tablet: {
                        spacing: {
                            paddingLeft: 4,
                            paddingRight: 4,
                        },
                    }, children: _jsx(HtmlInclude, { htmlFragment: preferenceData }) }) }), !isMobile && (_jsx(Box, { mobile: {
                    spacing: {
                        paddingTop: 3,
                        paddingLeft: 4,
                        paddingBottom: 4,
                    },
                }, children: _jsx(Button, { text: t('cookie.consent.back.button'), iconLeft: {
                        name: IconName.CHEVRON_LEFT,
                        size: IconSize.MAJOR,
                    }, onClick: handlePopoverClose }) }))] }));
};
export default CookiePreference;
